import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapperModal: ({ colors, spacing }) => css`
    p {
      margin: ${spacing.xs} 0 ${spacing.md} 0;
    }
    span {
      text-transform: capitalize;
      color: ${colors.brand.primary[300]};
    }
  `,
})

export { useStyles }
